if (!customElements.get('ep-collection-packs')) {
  customElements.define('ep-collection-packs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.products = JSON.parse(this.querySelector('.ep-pack-data').textContent);
      this.products.forEach(product => {
        product.variants = product.variants.filter(variant => product.optionValues.every((option, index) => option.values.includes(variant['option' + (index + 1)])));
      });
      this.main = this.products.find(p => String(p.id) === this.dataset.product);
      this.scope = this.closest('product-info') || this.closest('section');
      if (!this.main || !this.scope) return;
      this.initialized = true;
      this.qty = 1;
      this.mainVariant = this.main.variants.find(v => String(v.id) === this.dataset.variant) || this.main.variants.find(v => v.available);
      this.selections = Array.from({length: 3}, () => ({product: this.main, variant: this.mainVariant}));
      this.money = new Intl.NumberFormat('es-ES', {style: 'currency', currency: this.dataset.currency || 'EUR'});
      this.box = this.querySelector('.ep-pack-items');
      this.details = this.querySelector('.ep-pack-details');
      this.onChange = e => {
        if (!e.target.matches('.ep-pack-card input[type="radio"]')) return;
        this.qty = Number(e.target.value);
        this.querySelector('.ep-pack-error').hidden = true;
        this.renderItems();
        this.update();
      };
      this.addEventListener('change', this.onChange);
      this.onSubmit = e => {
        if (this.qty === 1 || !this.scope.contains(e.target) || !e.target.matches('form[data-type="add-to-cart-form"]')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        this.addPack();
      };
      document.addEventListener('submit', this.onSubmit, true);
      this.onNativeChange = e => {
        if (this.contains(e.target)) return;
        clearTimeout(this.syncTimer);
        this.syncTimer = setTimeout(() => this.syncMain(), 350);
      };
      this.scope.addEventListener('change', this.onNativeChange);
      this.observer = new MutationObserver(records => {
        if (records.some(r => !this.contains(r.target) && (r.target.matches?.('input[name="id"]') || [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('input[name="id"]') || n.querySelector?.('input[name="id"]')))))) this.syncMain();
      });
      this.observer.observe(this.scope, {subtree: true, childList: true, attributes: true, attributeFilter: ['value']});
      this.update();
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      document.removeEventListener('submit', this.onSubmit, true);
      this.scope?.removeEventListener('change', this.onNativeChange);
      this.scope?.classList.remove('ep-multi-pack');
      document.body.classList.remove('ep-multi-pack-page');
      this.observer?.disconnect();
      clearTimeout(this.syncTimer);
      this.initialized = false;
    }
    syncMain() {
      if (!this.isConnected) return;
      const input = this.scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      const variant = this.main.variants.find(v => String(v.id) === input?.value);
      if (!variant || variant.id === this.mainVariant?.id) return;
      this.mainVariant = variant;
      if (this.qty === 1) this.selections[0] = {product: this.main, variant};
      else if (this.selections[0].product.id === this.main.id) {
        this.selections[0].variant = variant;
        const row = this.box.querySelector('.ep-pack-item');
        if (row) this.refreshRow(row, this.selections[0]);
      }
      this.update();
    }
    format(cents) { return this.money.format(cents / 100); }
    totals(selections, count) {
      const subtotal = selections.reduce((sum, s) => sum + (s.variant?.price || 0), 0);
      return {subtotal, total: subtotal - Math.floor(subtotal * (count === 2 ? 10 : count === 3 ? 15 : 0) / 100)};
    }
    update() {
      const multi = this.qty > 1;
      this.scope.classList.toggle('ep-multi-pack', multi);
      document.body.classList.toggle('ep-multi-pack-page', multi);
      this.details.hidden = !multi;
      for (let count = 1; count <= 3; count++) {
        const selected = count === this.qty;
        const price = this.querySelector('[data-price="' + count + '"]');
        const before = this.querySelector('[data-before="' + count + '"]');
        price.closest('.ep-pack-card').classList.toggle('is-selected', selected);
        let total, original;
        if (count === 1) {
          total = this.mainVariant?.price || 0;
          original = Math.max(total, this.mainVariant?.compare_at_price || 0);
        } else {
          const selections = this.selections.slice(0, count);
          ({total} = this.totals(selections, count));
          original = selections.reduce((sum, selection) => sum + Math.max(selection.variant?.price || 0, selection.variant?.compare_at_price || 0), 0);
        }
        price.textContent = this.format(total);
        before.textContent = original > total ? this.format(original) : '';
        before.hidden = !before.textContent;
      }
      const button = this.scope.querySelector('form[data-type="add-to-cart-form"] button[name="add"]');
      if (button) {
        const label = button.querySelector('span');
        if (label) label.textContent = this.busy ? 'AÑADIENDO…' : multi || this.mainVariant?.available ? 'AÑADIR AL CARRITO' : 'AGOTADO';
        button.disabled = !!this.busy || (multi ? this.selections.slice(0, this.qty).some(s => !s.variant?.available) : !this.mainVariant?.available);
      }
    }
    renderItems() {
      this.box.replaceChildren();
      if (this.qty === 1) return;
      this.querySelector('[data-pack-count="' + this.qty + '"]').append(this.details);
      this.selections.slice(0, this.qty).forEach((selection, index) => {
        const row = document.createElement('div');
        row.className = 'ep-pack-item';
        this.box.append(row);
        this.renderRow(row, selection, index);
      });
    }
    imageFor(selection) {
      const image = selection.variant?.featured_image;
      const source = image?.src || image?.url || (typeof image === 'string' ? image : selection.product.image);
      if (!source) return '';
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', '160');
      return url.href;
    }
    renderRow(row, selection, index) {
      row.replaceChildren();
      const image = document.createElement('img');
      image.src = this.imageFor(selection);
      image.alt = selection.product.title + ' · ' + (selection.variant?.title || '');
      image.width = 64;
      image.height = 86;
      row.append(image);
      const fields = document.createElement('div');
      fields.className = 'ep-pack-fields';
      row.append(fields);
      const label = document.createElement('label');
      label.textContent = 'Prenda ' + (index + 1);
      const model = document.createElement('select');
      model.setAttribute('aria-label', 'Modelo de la prenda ' + (index + 1));
      for (const product of this.products) {
        const option = new Option(product.title, String(product.id));
        option.selected = product.id === selection.product.id;
        option.disabled = !product.variants.some(v => v.available);
        model.add(option);
      }
      label.append(model);
      fields.append(label);
      model.addEventListener('change', () => {
        const restoreKeyboardFocus = !window.matchMedia('(pointer: coarse)').matches;
        model.blur();
        const product = this.products.find(p => String(p.id) === model.value);
        const sizeIndex = selection.product.options.findIndex(name => /size|taille|talla/i.test(name));
        const size = selection.variant?.['option' + (sizeIndex + 1)];
        const nextSizeIndex = product.options.findIndex(name => /size|taille|talla/i.test(name));
        const variant = product.variants.find(v => v.available && size && nextSizeIndex >= 0 && v['option' + (nextSizeIndex + 1)] === size) || product.variants.find(v => v.available);
        selection = this.selections[index] = {product, variant};
        this.renderRow(row, selection, index);
        if (restoreKeyboardFocus) row.querySelector('select').focus({preventScroll: true});
        this.update();
      });
      const options = document.createElement('div');
      options.className = 'ep-pack-variant-options';
      fields.append(options);
      const names = selection.product.options || ['Variante'];
      names.forEach((name, optionIndex) => {
        const key = 'option' + (optionIndex + 1);
        const values = selection.product.optionValues[optionIndex].values;
        if (values.length === 1 && values[0] === 'Default Title') return;
        const optionLabel = document.createElement('label');
        optionLabel.textContent = /size|taille|talla/i.test(name) ? 'Talla' : /colou?r|couleur/i.test(name) ? 'Color' : name;
        const select = document.createElement('select');
        select.dataset.option = String(optionIndex);
        select.setAttribute('aria-label', optionLabel.textContent + ' de la prenda ' + (index + 1));
        for (const value of values) select.add(new Option(value, value));
        optionLabel.append(select);
        options.append(optionLabel);
        select.addEventListener('change', () => {
          if (window.matchMedia('(pointer: coarse)').matches) select.blur();
          const candidates = selection.product.variants.filter(v => v.available && v[key] === select.value);
          const variant = candidates.find(v => names.every((_, i) => i === optionIndex || v['option' + (i + 1)] === selection.variant?.['option' + (i + 1)])) || candidates[0];
          if (!variant) return;
          selection.variant = variant;
          this.refreshRow(row, selection);
          this.update();
        });
      });
      this.refreshRow(row, selection);
    }
    refreshRow(row, selection) {
      row.querySelectorAll('select[data-option]').forEach(select => {
        const index = Number(select.dataset.option);
        const key = 'option' + (index + 1);
        for (const option of select.options) {
          option.disabled = !selection.product.variants.some(v => v.available && v[key] === option.value && selection.product.options.every((_, previous) => previous >= index || v['option' + (previous + 1)] === selection.variant?.['option' + (previous + 1)]));
          option.textContent = option.value + (option.disabled ? ' · Agotado' : '');
        }
        select.value = selection.variant?.[key] || '';
      });
      const image = row.querySelector('img');
      image.src = this.imageFor(selection);
      image.alt = selection.product.title + ' · ' + (selection.variant?.title || '');
    }
    async addPack() {
      if (this.busy) return;
      const error = this.querySelector('.ep-pack-error');
      error.hidden = true;
      const chosen = this.selections.slice(0, this.qty);
      if (chosen.some(s => !s.variant?.available)) {
        error.textContent = 'Elige una opción disponible para cada prenda';
        error.hidden = false;
        return;
      }
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.querySelectorAll('input, select').forEach(control => control.disabled = true);
      this.update();
      let added = false;
      let linesUpdate;
      try {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!cart?.renderContents || !cart?.getSectionsToRender) throw new Error('No se ha podido abrir el carrito. Recarga la página e inténtalo de nuevo');
        cart.setActiveElement?.(document.activeElement);
        const items = new Map();
        for (const {variant} of chosen) items.set(variant.id, {id: variant.id, quantity: (items.get(variant.id)?.quantity || 0) + 1});
        const lines = [...items.values()];
        const CartLinesUpdateEvent = window.StandardEvents?.CartLinesUpdateEvent;
        if (CartLinesUpdateEvent) {
          linesUpdate = CartLinesUpdateEvent.createPromise();
          linesUpdate.promise.catch(() => {});
          this.dispatchEvent(new CartLinesUpdateEvent({action: 'add', context: 'product', lines: lines.map(line => ({merchandiseId: String(line.id), quantity: line.quantity})), promise: linesUpdate.promise}));
        }
        const root = window.Shopify?.routes?.root || '/';
        const sections = cart.getSectionsToRender().map(section => section.id);
        const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify({items: lines, sections, sections_url: window.location.pathname})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'No se ha podido añadir el pack. Revisa las opciones elegidas');
        added = true;
        if (linesUpdate) {
          fetch(root + 'cart.js').then(response => response.json()).then(data => linesUpdate.resolve({cart: CartLinesUpdateEvent.createCartFromAjaxResponse(data)})).catch(error => linesUpdate.reject(error));
        }
        if (sections.some(id => typeof result.sections?.[id] !== 'string')) {
          const query = new URLSearchParams({sections: sections.join(',')});
          const refreshed = await fetch(window.location.pathname + '?' + query);
          result.sections = await refreshed.json();
        }
        cart.classList.remove('is-empty');
        cart.renderContents(result);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: String(chosen[0].variant.id), cartData: result})).catch(() => {});
        }
      } catch (exception) {
        if (!added) linesUpdate?.reject(exception);
        error.textContent = added ? 'Las prendas ya están en tu carrito. Ábrelo desde el icono de la bolsa para verlas' : exception.message || 'No se ha podido añadir el pack. Inténtalo de nuevo';
        error.hidden = false;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.querySelectorAll('input, select').forEach(control => control.disabled = false);
        this.box.querySelectorAll('.ep-pack-item').forEach((row, index) => this.refreshRow(row, this.selections[index]));
        this.update();
      }
    }
  });
}
